import React from "react";
import { motion } from "framer-motion";
import "../assets/css/HowItWorks.css";
import AddLinkIcon from '@mui/icons-material/AddLink';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';

import imgLeft from "../assets/img/hero/HowItWorks-1.png";
import imgRight from "../assets/img/hero/HowItWorks-2.png";

const steps = [
    {
        icon: <AddLinkIcon className="step-icon" />,
        title: "1. Connect Accounts",
        desc: "Securely link your profiles. Comparedly works with Facebook, Instagram, and YouTube."
    },
    {
        icon: <CompareArrowsIcon className="step-icon" />,
        title: "2. Add Competitors",
        desc: "Type in any competitor's handle. We instantly pull their public data for benchmarking."
    },
    {
        icon: <AutoGraphIcon className="step-icon" />,
        title: "3. Get Insights",
        desc: "Unlock AI-driven reports, comparisons, and actionable strategies in seconds."
    }
];

const HowItWorks = () => {
    return (
        <section className="how-it-works-section" id="how-it-works">


            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                className="section-header"
            >
                <h2 className="section-title">From Data to Decisions in Seconds</h2>
                <p className="section-subtitle">Get started with Comparedly in 3 simple steps.</p>
            </motion.div>

            <div className="how-container">
                {/* Background Images - Anchored to container */}
                <img src={imgLeft} alt="" className="how-bg-image left" />
                <img src={imgRight} alt="" className="how-bg-image right" />

                {steps.map((step, index) => (
                    <motion.div
                        key={index}
                        className="step-card"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        whileHover={{ y: -10, transition: { duration: 0.25 } }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: index * 0.2 }}
                    >
                        <div className="step-icon-wrapper">
                            {step.icon}
                        </div>
                        <h3 className="step-title">{step.title}</h3>
                        <p className="step-desc">{step.desc}</p>
                    </motion.div>
                ))}
            </div>
        </section>
    );
};

export default HowItWorks;
